import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * /sunrise-2027 used to host a standalone Sunrise 2027 reference page on the
 * tool-shaped ToolLayout chrome. The same topic now lives at
 * /barcode-guides/sunrise-2027-explained as a proper long-form guide on the
 * GuideLayout pattern.
 *
 * To eliminate the duplication while preserving the SEO equity and every
 * inbound link to the old URL, this route is now a permanent (301) redirect
 * to the new canonical location. TanStack Router's `redirect()` throws
 * during `beforeLoad` so the response is issued before any HTML is
 * rendered — both SSR (the Cloudflare response carries the 3xx status) and
 * client navigation (history.replaceState to the new URL) hand off cleanly.
 */
export const Route = createFileRoute("/sunrise-2027")({
  beforeLoad: () => {
    throw redirect({
      to: "/barcode-guides/sunrise-2027-explained",
      statusCode: 301,
    });
  },
  component: () => null,
});
